import { getCachedObj, removeCache } from "@/utils/cache"

/**
 * 缓存网络请求
 * 被装饰的函数的参数,最后一个参数必须是cache,类型是bool,用于表示是否缓存结果.
 *    其余的参数,如果要作为缓存的键,则不能设置默认参数
 * @param timeout
 * @returns {(function(*, *, *): void)|*}
 */
export const cacheRequest = function(timeout = 60 * 30) {
  return function(target, name, descriptor) {
    let rawFunc = descriptor.value
    descriptor.value = function(...args) {
      if (!args.length) {
        return Promise.reject("参数有误")
      }
      let realArgs = args.slice(0, args.length - 1)
      let reqFunc = () => rawFunc.call(this, ...realArgs)
      let key = `${name}_${JSON.stringify(realArgs)}`
      if (args[args.length - 1] === false) {
        removeCache(key)
      }
      return getCachedObj({ key, reqFunc, timeout })
    }
  }
}
